module.exports = __webpack_public_path__ + "static/media/image1.4fb9278d.png";